import React, { useState } from 'react';
import styled from 'styled-components';
import { Anchor } from './Anchor';
import { Box } from './Box';
import { Text } from './Text';

const Wrapper = styled(Box)`
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;

const Triangle = styled(Text)<{ $hovered: boolean }>`
  color: var(--dark-red);
  transition: transform 0.25s ease;
  transform: ${({ $hovered }) => ($hovered ? 'scale(1.3)' : 'scale(1)')};
`;

const Link = styled(Anchor)`
  text-decoration: none;
`;

export function NewsletterSignupInternalLink() {
  const [hovered, setHovered] = useState(false);

  return (
    <Wrapper>
      <Triangle as="span" $hovered={hovered}>
        ▲
      </Triangle>

      <Link
        href="#newsletter"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Text
          as="span"
          fontSize={['1.25rem', '1.5rem']}
          fontWeight="bold"
          fontFamily="VAL"
          color="var(--dark-brown)"
          letterSpacing="var(--display-spacing-sm)"
        >
          Newsletter Signup
        </Text>
      </Link>

      <Triangle as="span" $hovered={hovered}>
        ▲
      </Triangle>
    </Wrapper>
  );
}
